import extend from '../utils/extend';
import loadGMapAPI from '../map/loadGMapApi';

/* global google */

export default class PlaceSearch {
  // Inti variables and settings
  constructor($root, options) {
    this.$root = $root;

    this.options = extend({
      inputSelector: '.js-place-search-input',
      geolocSelector: '.js-place-search-geoloc',
      latInputSelector: '.js-place-search-lat',
      lngInputSelector: '.js-place-search-lng',
      submit: '[type="submit"]',
      autoSubmitOnPlaceChange: false,
      onNewCoordinates: () => {},
    }, options);

    this.$input = $root.querySelector(this.options.inputSelector);
    this.$geolocBtn = $root.querySelector(this.options.geolocSelector);
    this.$latInput = $root.querySelector(this.options.latInputSelector);
    this.$lngInput = $root.querySelector(this.options.lngInputSelector);
    this.$submit = $root.querySelector(this.options.submit);

    this.autocomplete = null;

    this.handlePlaceChange = this.handlePlaceChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTyping = this.handleTyping.bind(this);
    this.handleGeoloc = this.handleGeoloc.bind(this);

    this.isMounted = false;
  }

  // Setup component
  async mount() {
    await loadGMapAPI();

    if (!this.autocomplete) {
      this.autocomplete = new google.maps.places.Autocomplete(this.$input, {
        componentRestrictions: { country: ['fr', 'be', 'ch', 'lu'] },
      });
    }

    this.autocomplete.addListener('place_changed', this.handlePlaceChange);

    if (this.$root.nodeName === 'FORM') {
      this.$root.addEventListener('submit', this.handleSubmit);
    } else {
      this.$submit.addEventListener('click', this.handleSubmit);
    }

    this.$input.addEventListener('keyup', this.handleTyping);

    if (this.$geolocBtn) {
      this.$geolocBtn.addEventListener('click', this.handleGeoloc);
    }

    this.isMounted = true;
  }

  // Reset component
  unmount() {
    google.maps.event.clearInstanceListeners(this.autocomplete);

    if (this.$root.nodeName === 'FORM') {
      this.$root.removeEventListener('submit', this.handleSubmit);
    } else {
      this.$submit.removeEventListener('click', this.handleSubmit);
    }

    this.$input.removeEventListener('keyup', this.handleTyping);

    if (this.$geolocBtn) {
      this.$geolocBtn.removeEventListener('click', this.handleGeoloc);
    }

    this.isMounted = false;
  }

  // Update coordinates and enable form's submission
  handlePlaceChange() {
    const place = this.autocomplete.getPlace();

    if (place.geometry) {
      this.$latInput.value = place.geometry.location.lat();
      this.$lngInput.value = place.geometry.location.lng();

      if (this.options.autoSubmitOnPlaceChange) {
        this.dispatchNewCoordinates();
      }
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.$latInput.value && this.$lngInput.value) {
      this.dispatchNewCoordinates();
    }
  }

  // Trigger defined callback when coordinates are changing (new location, clear)
  dispatchNewCoordinates() {
    const coords = this.$latInput.value && this.$lngInput.value ? {
      lat: parseFloat(this.$latInput.value),
      lng: parseFloat(this.$lngInput.value),
    } : false;

    this.options.onNewCoordinates(coords);
  }

  // Prevent user to submit form if searching anything else that isn't a google place
  handleTyping() {
    this.$latInput.value = '';
    this.$lngInput.value = '';
  }

  handleGeoloc() {
    this.$geolocBtn.classList.add('is-loading');

    navigator.geolocation.getCurrentPosition((position) => {
      this.$geolocBtn.classList.remove('is-loading');
      this.$input.value = 'Autour de ma position';
      this.$latInput.value = position.coords.latitude;
      this.$lngInput.value = position.coords.longitude;

      if (this.options.autoSubmitOnPlaceChange) {
        this.dispatchNewCoordinates();
      }
    }, (e) => {
      this.$geolocBtn.classList.remove('is-loading');
    });
  }

  clear() {
    this.$input.value = '';
    this.$latInput.value = '';
    this.$lngInput.value = '';
  }
}
